import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "@/constants/site";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");

    const exchange = async () => {
      try {
        const r = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!r.ok) throw new Error("session exchange failed");
        const user = await r.json();
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.is_admin ? "/admin" : "/", { state: { user }, replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="auth-callback-loading">
      <div className="flex items-center gap-3 text-slate-600">
        <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
        <span>Accesso in corso...</span>
      </div>
    </div>
  );
}
